import { checkPropTypes } from 'prop-types'
import React from 'react'

export default function CloseIcon({ styles, width, height }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0847 14.139L12.2563 11.3106L15.0847 8.48217L14.1419 7.53936L11.3135 10.3678L8.48505 7.53936L7.54224 8.48217L10.3707 11.3106L7.54224 14.139L8.48505 15.0818L11.3135 12.2534L14.1419 15.0818L15.0847 14.139Z"
        fill="#E41B1B"
      />
    </svg>
  )
}

CloseIcon.propTypes = {
  styles: checkPropTypes.any,
  width: checkPropTypes.string,
  height: checkPropTypes.string,
}
